import { render, staticRenderFns } from "./RPUser.vue?vue&type=template&id=2e20788a"
import script from "./RPUser.vue?vue&type=script&lang=js"
export * from "./RPUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports